import AdminView from './AdminView';
import UserView from './UserView';
import { useRole } from '../../../hooks/useRole';

export default function BulkRequests() {
	const { isAdmin } = useRole();
	return isAdmin ? <AdminView /> : <UserView />;
}
